import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { InputField } from "@src/shared/ui/InputField";
import CheckIcon from "@mui/icons-material/Check";
import { numbersOnly } from "@src/shared/utils";

import styles from "./SalaryRangeAccordion.module.scss";

interface Props {
  isDisabledFields: boolean;
}

export const SalaryRangeAccordion = ({ isDisabledFields }: Props) => {
  const { control, trigger, watch } = useFormContext();
  const [expanded, setExpanded] = useState(true);

  const salaryFrom = watch("salary_from");
  const salaryTo = watch("salary_to");

  useEffect(() => {
    trigger(["salary_from", "salary_to"]);
  }, [salaryFrom, salaryTo, trigger]);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion
      defaultExpanded
      expanded={expanded}
      sx={{
        mt: 4,
        backgroundColor: "#ffffff",
        borderRadius: "25px",
        opacity: 1,
        padding: "17px 30px",
        color: "rgba(38, 38, 38, 1)",
        marginTop: "10px",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        sx={{
          backgroundColor: "inherit",
          height: "30px",
          px: 0,
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
        }}
      >
        <Box
          onClick={handleToggle}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            cursor: "pointer",
            width: "100%",
            height: "30px",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          <h3>Условия найма</h3>
          <div className={styles.iconWrapper}>
            {expanded ? (
              <ExpandLess sx={{ color: "rgba(164, 187, 199, 1)" }} />
            ) : (
              <ExpandMore sx={{ color: "rgba(164, 187, 199, 1)" }} />
            )}
          </div>
        </Box>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          px: 0,
          backgroundColor: "inherit",
          py: 0,
          mt: 0,
          mb: 0,
          gap: 0,
          borderTop: "1px solid rgba(164, 187, 199, 0.25)",
          paddingTop: "20px",
        }}
      >
        <div className={styles.salaryWrapper}>
          <div className={styles.salaryTitle}>
            <span>Уровень зарплаты:</span>
          </div>

          <div className={styles.salaryFields}>
            <InputField
              control={control}
              name="salary_from"
              placeholder="От"
              className={styles.inputField}
              inputFilter={numbersOnly}
              disabled={isDisabledFields}
            />

            <span className={styles.def}>—</span>

            <InputField
              control={control}
              name="salary_to"
              placeholder="До"
              className={styles.inputField}
              inputFilter={numbersOnly}
              disabled={isDisabledFields}
            />
          </div>
        </div>

        <Controller
          name="showWithout"
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  disabled={isDisabledFields}
                  checked={field.value}
                  icon={<span className={styles.customBox} />}
                  checkedIcon={
                    <span className={`${styles.customBox} ${styles.checked}`}>
                      <CheckIcon />
                    </span>
                  }
                />
              }
              label="Показывать кандидатов без указанной зарплаты"
              className={styles.salaryLabel}
            />
          )}
        />
      </AccordionDetails>
    </Accordion>
  );
};
